
/* eslint-disable */
/*
 * @Descripttion: 
 * @version: 
 * @Author: susj
 * @Date: 2020-10-15 15:52:44
 * @LastEditors: yinj
 * @LastEditTime: 2021-02-20 14:46:35
 */

import insertObj from '@/utils/insertData';
import {abbr2sty,findObjItem} from '@/utils/element.js'
export default (asyncData) => {

  const pageData = JSON.parse(JSON.stringify(asyncData).replace(/slideResults/g, 'pages').replace(/slideInfoResults/g, 'elements').replace(/elementType/g, 'name'))
  if (!pageData.elements) {
    pageData.elements = []
  }
  pageData.uuid = asyncData.id;
  const bgObj = {
    name: 'ppt-background',
    uuid: pageData.id,
    id: pageData.id,
    slideId: pageData.id,
    pptId: pageData.pptId,
    bgImage: pageData.bgImage || '',
    bgColor: pageData.bgColor || '',
  };
  pageData.elements.unshift(bgObj);
  pageData.elements.forEach((ele) => {
    ele.uuid = ele.id;
    ele.pluginProps = {};
    ele.commonStyle = {};
    ele.name === 'image' && (ele.name = 'ppt-picture');
    ele.name === 'text' && (ele.name = 'ppt-text');
    ele.name === 'table' && (ele.name = 'ppt-table');
    if (ele.name === 'ppt-table') {
      ele.pluginProps.table = JSON.parse(ele.content);
      ele.pluginProps.areaContentType = ele.areaContentType; // 报价表格类型
      const { row_height, column_width } = ele.pluginProps.table;
      ele.pluginProps.width = column_width.reduce((pre, cur) => Number(pre) + Number(cur));
      ele.pluginProps.height = row_height.reduce((pre, cur) => Number(pre) + Number(cur));
    }
    if (ele.name === 'area') {
      ele.name = ele.type === 'text' ? 'ppt-text-template' : 'ppt-picture-template';
      ele.pluginProps.contentType = ele.contentType
      // ele.pluginProps.contentName = '方案信息-详细地址'
      const areaName=findObjItem(insertObj.insertData,'val', ele.type).name
      const itemNameObj=findObjItem(insertObj.insertDataItem[ele.type],'val', ele.contentType);
      const itemName=itemNameObj?'-'+itemNameObj.name:'';
      ele.pluginProps.contentName=areaName+ itemName;
      ele.pluginProps.areaType = ele.type
    }
    ele.uuid && (ele.pluginProps.uuid = ele.id);
    ele.content && (ele.pluginProps.content = abbr2sty(ele.content));
    ele.bgColor && (ele.pluginProps.bgColor = ele.bgColor);
    ele.bgImage && (ele.pluginProps.bgImage = ele.bgImage);
    ele.imagePath && (ele.pluginProps.imagePath = ele.imagePath);
    ele.backgroundColor && (ele.pluginProps.backgroundColor = ele.backgroundColor);
    ele.top && (ele.commonStyle.top = ele.top);
    ele.left && (ele.commonStyle.left = ele.left);
    ele.width && (ele.commonStyle.width = ele.width);
    ele.height && (ele.commonStyle.height = ele.height);
    ele.textAlign && (ele.commonStyle.textAlign = ele.textAlign);
    ele.color && (ele.commonStyle.color = ele.color);
    ele.backgroundColor && (ele.commonStyle.backgroundColor = ele.backgroundColor);
    ele.fontSize && (ele.commonStyle.fontSize = ele.fontSize);
    ele.rotation && (ele.commonStyle.rotation = ele.rotation);
    ele.flipHorizontal && (ele.commonStyle.flipHorizontal = ele.flipHorizontal);
    ele.flipVertical && (ele.commonStyle.flipVertical = ele.flipVertical);
  });
  return pageData;
};
